const ADJACENCY_CONTROL_OPTIONS = {
    ADJACENCY_CONTROL: 'Adjacency Control',
};

export default ADJACENCY_CONTROL_OPTIONS;
